"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var util_localization_1 = require("@sport-thieme/util-localization");
var InputBase_1 = __importDefault(require("@material-ui/core/InputBase"));
var styles_1 = require("@material-ui/core/styles");
var __1 = require("..");
var core_1 = require("@material-ui/core");
var SearchField = react_1.forwardRef(function SearchField(_a, ref) {
    var _b;
    var _c = _a.autoFocus, autoFocus = _c === void 0 ? false : _c, className = _a.className, _d = _a.color, color = _d === void 0 ? 'onBackground' : _d, clearFilter = _a.clearFilter, onSearch = _a.onSearch, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.forceFocusStyle, forceFocusStyle = _f === void 0 ? false : _f, focusClassName = _a.focusClassName, action = _a.action, _g = _a.loading, loading = _g === void 0 ? false : _g, onBlur = _a.onBlur, onChange = _a.onChange, _h = _a.iconColor, iconColor = _h === void 0 ? 'primary' : _h, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, _j = _a.placeholder, placeholder = _j === void 0 ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Search\u2026"], ["Search\u2026"]))) : _j, _k = _a.value, value = _k === void 0 ? '' : _k;
    var _l = react_1.useState(''), input = _l[0], setInput = _l[1];
    var _m = react_1.useState(false), focus = _m[0], setFocus = _m[1];
    var classes = useStyles({ focus: forceFocusStyle || focus });
    react_1.useEffect(function () {
        if (value !== input)
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(input);
    }, [input, onSearch]);
    react_1.useEffect(function () {
        if (typeof value === 'string') {
            setInput(value !== null && value !== void 0 ? value : '');
        }
        else
            setInput('');
    }, [value]);
    var handleChange = function (e) {
        setInput(e.currentTarget.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    var handleOnClick = function () {
        if (clearFilter) {
            clearFilter();
        }
        setInput('');
    };
    var colorClass;
    switch (color) {
        case 'onPrimary':
            colorClass = classes.colorAppBar;
            break;
        case 'onBackground':
            colorClass = classes.colorBackground;
            break;
        case 'onPaper':
            colorClass = classes.colorPaper;
            break;
    }
    var loadingColor = (['primary', 'secondary', 'inherit'].includes(iconColor)
        ? iconColor
        : 'inherit');
    return (jsx_runtime_1.jsxs(__1.Grid, __assign({ container: true, alignItems: "center", alignContent: "center", wrap: "nowrap", className: classnames_1.default(className, classes.inputWrapper, colorClass, (_b = {},
            _b[focusClassName !== null && focusClassName !== void 0 ? focusClassName : ''] = forceFocusStyle || focus,
            _b)), spacing: 1, ref: ref }, { children: [jsx_runtime_1.jsx(__1.Grid, __assign({ item: true, className: classes.searchIcon }, { children: loading ? (jsx_runtime_1.jsx(__1.CircularProgress, { color: loadingColor, size: "18px", className: classes.loading }, void 0)) : (jsx_runtime_1.jsx(__1.Icon.Search, { color: iconColor }, void 0)) }), void 0),
            jsx_runtime_1.jsx(__1.Grid, __assign({ item: true, grow: true }, { children: jsx_runtime_1.jsx(InputBase_1.default, { fullWidth: true, autoFocus: autoFocus, placeholder: placeholder, value: input, onChange: handleChange, onKeyUp: onKeyUp, onKeyDown: onKeyDown, onBlur: function (event) {
                        setFocus(false);
                        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                    }, onFocus: function (event) {
                        setFocus(true);
                        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                    }, disabled: disabled }, void 0) }), void 0),
            jsx_runtime_1.jsx(core_1.Grow, __assign({ in: Boolean(input) }, { children: jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: jsx_runtime_1.jsx(__1.Tooltip, __assign({ title: util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["clear search"], ["clear search"]))), enterDelay: 2000 }, { children: jsx_runtime_1.jsx(__1.IconButton, __assign({ onClick: handleOnClick, color: "default", size: "small" }, { children: jsx_runtime_1.jsx(__1.Icon.Clear, { fontSize: "small", color: "action" }, void 0) }), void 0) }), void 0) }), void 0) }), void 0),
            Boolean(action) && jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: action }), void 0)] }), void 0));
});
exports.default = SearchField;
var colorWithAlpha = function (colorString, alpha) {
    if (alpha === void 0) { alpha = 1; }
    var color = styles_1.decomposeColor(colorString);
    color.type = 'rgba';
    color.values.push(alpha);
    return styles_1.recomposeColor(color);
};
var useStyles = styles_1.makeStyles(function (theme) { return ({
    inputWrapper: {
        borderRadius: theme.shape.borderRadius,
        paddingRight: theme.spacing(),
        paddingLeft: theme.spacing(),
        transition: 'background .6s',
    },
    loading: {
        margin: 3,
    },
    colorAppBar: {
        backgroundColor: function (_a) {
            var focus = _a.focus;
            return focus ? theme.palette.background.paper : colorWithAlpha(theme.palette.background.paper, 0.5);
        },
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
        },
    },
    searchIcon: {
        display: 'flex',
    },
    colorPaper: {
        backgroundColor: function (_a) {
            var focus = _a.focus;
            return focus
                ? theme.palette.background.default
                : colorWithAlpha(theme.palette.background.default, 0.8);
        },
        '&:hover': {
            backgroundColor: theme.palette.background.default,
        },
    },
    colorBackground: {
        backgroundColor: function (_a) {
            var focus = _a.focus;
            return focus
                ? colorWithAlpha(styles_1.lighten(theme.palette.primary.main, 0.7), 0.3)
                : colorWithAlpha(theme.palette.background.paper, 0.8);
        },
        '&:hover': {
            backgroundColor: colorWithAlpha(styles_1.lighten(theme.palette.primary.main, 0.7), 0.3),
        },
    },
}); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=SearchField.js.map